import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNoteSticky,
  faPlus,
  faShareNodes,
  faEye,
  faCalendarDays,
} from "@fortawesome/free-solid-svg-icons";

const dummyNotes = [
  {
    id: "NOTE-001",
    appointmentId: "GAS-APT-001",
    agenda: "Vendor Discussion",
    date: "2025-01-10",
    summary: "Vendor agreed to reduce pricing by 5% and start pilot order.",
    action: "Send pilot order email",
  },
  {
    id: "NOTE-002",
    appointmentId: "GAS-APT-003",
    agenda: "Investor Meeting",
    date: "2025-01-12",
    summary: "Investor requested revenue metrics and growth projections.",
    action: "Prepare financial deck",
  },
];

const GASAppointmentNotes = () => {
  const [notes, setNotes] = useState(dummyNotes);

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-semibold flex items-center gap-2">
          <FontAwesomeIcon icon={faNoteSticky} />
          Appointment Notes
        </h1>

        <button className="flex items-center gap-2 text-xs px-3 py-2 border border-cyan-600 rounded">
          <FontAwesomeIcon icon={faPlus} />
          New Note
        </button>
      </div>

      {/* Notes List */}
      {notes.map((note) => (
        <div
          key={note.id}
          className="border border-cyan-800 rounded-xl p-4 mb-4"
        >
          <h2 className="font-semibold text-sm">{note.agenda}</h2>

          <div className="text-xs text-gray-400 flex items-center gap-2 mt-1">
            <FontAwesomeIcon icon={faCalendarDays} />
            {note.date} | {note.appointmentId}
          </div>

          <p className="text-sm mt-3">
            <span className="font-semibold">Summary:</span> {note.summary}
          </p>

          <p className="text-sm mt-1 text-cyan-300">
            <span className="font-semibold">Action:</span> {note.action}
          </p>

          <div className="flex gap-4 mt-4 text-xs">
            <button className="flex items-center gap-1 border border-cyan-600 px-3 py-1 rounded">
              <FontAwesomeIcon icon={faEye} />
              View
            </button>

            <button className="flex items-center gap-1 border border-cyan-600 px-3 py-1 rounded">
              <FontAwesomeIcon icon={faShareNodes} />
              Share
            </button>
          </div>
        </div>
      ))}

      {notes.length === 0 && (
        <p className="text-sm text-gray-500">
          No appointment notes available.
        </p>
      )}
    </div>
  );
};

export default GASAppointmentNotes;
